var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.518 9.49703C18.5213 10.7436 18.23 11.9733 17.668 13.0859C17.0017 14.4192 15.9773 15.5407 14.7095 16.3247C13.4418 17.1087 11.9808 17.5242 10.4903 17.5248C9.24373 17.528 8.01405 17.2368 6.90139 16.6748L1.51807 18.4692L3.31251 13.0859C2.7505 11.9733 2.45926 10.7436 2.46251 9.49703C2.46309 8.00647 2.87864 6.54551 3.66263 5.27778C4.44662 4.01005 5.56808 2.98563 6.90139 2.31926C8.01405 1.75726 9.24373 1.46602 10.4903 1.46927H10.9625C12.931 1.57787 14.7904 2.40876 16.1845 3.80285C17.5785 5.19694 18.4094 7.05626 18.518 9.02481V9.49703Z",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.e5968ba26981fd8ef8476ca3a10f06ea.svg";
export { ForwardRef as ReactComponent };